import { WritableAtom } from 'jotai';
import {
  CaptableSummaryColumnType,
  CaptableSummaryGridPreferences,
  createCaptableSummaryGridPreferences,
  getOrgPreferenceKey,
  PreferenceKey,
  PreferenceScope,
} from '../../../../data-models/preferences-v3.data-model';
import { preferenceAtom } from '../../../../util/preferences-service-v3';

export const DefaultCaptableInvestmentColumnOrder: CaptableSummaryColumnType[] = [
  CaptableSummaryColumnType.amount,
  CaptableSummaryColumnType.noOfShares,
  CaptableSummaryColumnType.ownershipPercentage,
];

export const CaptableSummaryColumnLabels: Record<CaptableSummaryColumnType, string> = {
  [CaptableSummaryColumnType.amount]: 'Invested Amount',
  [CaptableSummaryColumnType.noOfShares]: 'Shares Held',
  [CaptableSummaryColumnType.ownershipPercentage]: 'Ownership Percentage',
};

export const captableSummaryPreferencesAtom = preferenceAtom(
  {
    preferenceKey: getOrgPreferenceKey(PreferenceKey.captableSummaryGrid, null),
    scope: PreferenceScope.USER,
  },
  undefined,
  createCaptableSummaryGridPreferences({
    investmentColumnOrder: DefaultCaptableInvestmentColumnOrder,
    pinTotalColumns: false,
  })
) as WritableAtom<CaptableSummaryGridPreferences, [newValue: CaptableSummaryGridPreferences], void>;
